// src/pages/Publications.jsx - Cleaned up version
import React, { useState, useEffect } from 'react';
import PublicationCard from '../components/PublicationCard';
import publicationsData from '../data/publications.json';

const categoriesData = [
  {
    "id": "cloud-architecture",
    "name": "Cloud Architecture",
    "description": "Cloud-native patterns and infrastructure design",
    "color": "#3B82F6",
    "icon": "☁️"
  },
  {
    "id": "data-engineering",
    "name": "Data Engineering",
    "description": "Data pipelines, modeling, and processing systems",
    "color": "#10B981",
    "icon": "📊"
  },
  {
    "id": "leadership",
    "name": "Leadership",
    "description": "Technical leadership and team management",
    "color": "#8B5CF6",
    "icon": "👥"
  },
  {
    "id": "system-design",
    "name": "System Design",
    "description": "Scalable system architecture and design patterns",
    "color": "#F59E0B",
    "icon": "🏗️"
  }
];

const Publications = () => {
  const [publications, setPublications] = useState([]);
  const [filteredPublications, setFilteredPublications] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    // Sort by date (newest first)
    const sortedPublications = [...publicationsData].sort((a, b) => 
      new Date(b.date) - new Date(a.date)
    );
    setPublications(sortedPublications);
    setFilteredPublications(sortedPublications);
  }, []);

  useEffect(() => {
    let filtered = [...publications];
    
    if (selectedCategory !== 'all') {
      filtered = filtered.filter(pub => pub.category === selectedCategory);
    }
    
    if (searchTerm) {
      const term = searchTerm.toLowerCase();
      filtered = filtered.filter(pub => 
        pub.title.toLowerCase().includes(term) ||
        pub.excerpt.toLowerCase().includes(term) ||
        pub.tags.some(tag => tag.toLowerCase().includes(term))
      );
    }
    
    setFilteredPublications(filtered);
  }, [selectedCategory, searchTerm, publications]);

  const featuredPublications = publications.filter(pub => pub.featured).slice(0, 3);

  return (
    <section className="full-section publications-page">
      <div className="section-header-full">
        <h1>Publications</h1>
        <p>Technical articles and insights on architecture, data, and product strategy</p>
      </div>

      {featuredPublications.length > 0 && (
        <div className="featured-publications">
          <h2>Featured Articles</h2>
          <div className="featured-grid">
            {featuredPublications.map(pub => (
              <PublicationCard key={pub.id} publication={pub} featured={true} />
            ))}
          </div>
        </div>
      )}

      <div className="publications-filter">
        <div className="search-box">
          <input
            type="text"
            placeholder="Search publications..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
        </div>
        
        <div className="category-filters">
          <button
            className={`category-filter ${selectedCategory === 'all' ? 'active' : ''}`}
            onClick={() => setSelectedCategory('all')}
          >
            All
          </button>
          {categoriesData.map(category => (
            <button
              key={category.id}
              className={`category-filter ${selectedCategory === category.name ? 'active' : ''}`}
              onClick={() => setSelectedCategory(category.name)}
              style={{ borderLeftColor: category.color }}
            >
              {category.icon} {category.name}
            </button>
          ))}
        </div>
      </div>

      <div className="publications-grid-full">
        {filteredPublications.length > 0 ? (
          filteredPublications.map(pub => (
            <PublicationCard key={pub.id} publication={pub} />
          ))
        ) : (
          <div className="no-results">
            <h3>No publications found</h3>
            <p>Try adjusting your search or filter criteria</p>
          </div>
        )}
      </div>

      <div className="publication-cta">
        <h2>Want to discuss these topics further?</h2>
        <p>Book a consultation to dive deeper into any of these subjects</p>
        <button 
          className="btn-primary"
          onClick={() => window.open('https://calendly.com/ayoub-abdelouahabi/meeting', '_blank')}
        >
          Schedule a Call
        </button>
      </div>
    </section>
  );
};

export default Publications;